import React, { Component } from 'react';
import { Link, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { track404 } from '../actions/trackingActions';
import { Helmet } from 'react-helmet';


export const RedirectAs404 = ({ location }) => <Redirect to={Object.assign({}, location, { state: { is404: true } })} />;

class Error404 extends Component {
  componentDidMount () {
    const { actions, location } = this.props;
    actions.track404({ path: location.pathname });
  }

  render () {
    // TODO: i18n hardcoded strings
    return (
      <div className="title-wrapper">
        <div className="title-default-container">
          <Helmet>
            <title>404 - Page Not Found</title>
            <meta name="robots" content="noindex" />
          </Helmet>
          <header>
            <h1 className="mb-3">Error 404</h1>
          </header>
          <p>
            We’re sorry, but the page you requested could not be found. <Link to="/">Return to the project homepage</Link>.
          </p>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ track404 }, dispatch),
});

export default withRouter(connect(null, mapDispatchToProps)(Error404));



// WEBPACK FOOTER //
// ./src/components/Error404.js